export { Heading } from "./Heading"
